import React from 'react';

/** Redirects to the `p` query-param URL, or home if absent. */
export const RedirectionPage = () => {
  const params = new URLSearchParams(location.search);
  const p = params.get('p');
  if (p) window.location.href = p;
  else window.location.href = '/';
  return <div></div>;
};